import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    maxWidth: 600,
    minWidth: 300,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  walletInfo: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 6,
    margin: '12px 0px'
  },
  walletInfoContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    background: theme.palette.grey[200],
    padding: 8
  },
  titleColor: {
    color: theme.palette.grey[500]
  },
  amountSection: {
    width: '100%',
    display: 'grid',
    alignItems: 'center',
    gridTemplateRows: '1fr 1fr'
  },
  loadError: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(4, 0)
  },
  buttons: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 36
  },
  saveButton: {
    marginLeft: 12
  },
  switches: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  switch: {
    width: '130%'
  },
  inputSkeleton: { width: '100%', margin: '22px 0px' }
}))

export default useStyles
